import React, { useState, useEffect, useRef, useContext } from "react";
import CaseDetails from "../components/core/caseDetails";

import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import JisCheckbox from "../components/controls/jisCheckbox";
import JisYesNo from "../components/controls/jisYesNo";
import JisDialog from "../components/dialog";
function CaseDetailsAll() {
  const { activePage, token, profile, setIsExpired } = useContext(ShareContext);
  const { caseid } = useParams();
  const [loading, setLoading] = useState(false);
  /* 
      const [data, setData] = useState(null);


   useEffect(() => {
          onLoad();       
    }, []);

  const onLoad= async()=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/filing/case-details/${caseid}`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  //ready
                  // fee, feelines, cinfo , parties 
                setData(data)
  
              } else if(data.code==-10){
                      setIsExpired(true);
                  }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          } */
  return (
    <div>
      {/* <h4>Case Details</h4> */}

      <CaseDetails caseId={caseid} data={null} />
      {/* Add your login form UI here */}

      <BackLoader open={loading} />
    </div>
  );
}

export default CaseDetailsAll;
